import { BaseController } from '@maia/feature-utils';
import {
  ActivityDto,
  ActivityService,
  ClaimDto,
  ClaimService,
  NoteDto,
  NoteService,
  TaskDto,
  TaskService,
} from '@maia/shared';

export class ClaimController extends BaseController {
  constructor(
    private claimService: ClaimService,
    private activityService: ActivityService,
    private notesService: NoteService,
    private tasksService: TaskService,
  ) {
    super();
  }

  async getClaims(search: Record<string, unknown>) {
    return await this.getEntities(
      this.claimService,
      { path: 'claims', search },
      ClaimDto,
    );
  }

  async getClaim(guid: string) {
    return await this.getEntity(this.claimService, `claims/${guid}`, ClaimDto);
  }

  async getActivities(guid: string, search: Record<string, unknown>) {
    return this.getEntities(
      this.activityService,
      { path: `claims/${guid}/activities`, search },
      ActivityDto,
    );
  }

  async getNotes(guid: string, search: Record<string, unknown>) {
    return this.getEntities(
      this.notesService,
      { path: `claims/${guid}/notes`, search },
      NoteDto,
    );
  }

  async getTasks(guid: string, search: Record<string, unknown>) {
    return this.getEntities(
      this.tasksService,
      { path: `claims/${guid}/tasks`, search },
      TaskDto,
    );
  }

  async createClaim(
    customerGuid: Parameters<typeof this.claimService.create>[0],
    params: Parameters<typeof this.claimService.create>[1],
  ) {
    return await this.claimService.create(customerGuid, params);
  }

  async createNote(
    path: Parameters<typeof this.notesService.create>[0],
    params: Parameters<typeof this.notesService.create>[1],
  ) {
    return await this.notesService.create(path, params);
  }

  async sendSmartLink(
    params: Parameters<typeof this.claimService.smartlink>[number],
  ) {
    return await this.claimService.smartlink(params);
  }
}
